import FontSetBox from "@/component/fontSetBox";
import { useEffect, useMemo, useRef, useState } from "react";
import style from "./index.module.less";
import { RightOutline } from "antd-mobile-icons";
import { ActivityData } from "../../type";
import { createTeam, signUp } from "../../ajax";
import PopUpInfoCom from "@/component/popUpInfoCom";
import { getCurrentUid } from "@/api/common";
import { goToPageV2 } from "@/utils/common";
import PopupCom from "@/component/popupCom";
import { Input, Loading, Toast } from "@xp-design/mobile";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";
import { Filter } from "bad-words";
import { enhancedSafeChainFind } from "@/pages/par-marketing/configPage/utils";
import ActivityValueDetailPopup, {
  ActivityValueDetailPopupRef,
} from "@/components/ActivityValueDetailPopup";
import iconMore from "@/assets/icon_more.svg";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { PageDataConfig } from "@/types/config-page";
import { processOssImage } from "@/utils/image";
import {
  appendParamsToUrl,
  getParamsFromHash,
  removeUrlParameters,
} from "@/utils/url";
interface props {
  infoObj: ActivityData;
  moduleJsonData: {
    base?: Array<Record<string, unknown>>;
    visual: {
      prizeSetting?: Array<Record<string, unknown>>;
      visualData?: Array<Record<string, unknown>>;
    };
  };
  activityInfo: Record<string, unknown>;
  isPeoModel: boolean;
  onRefresh: (flag: boolean) => void;
  teamConfigData: {
    memberList?: Array<Record<string, unknown>>;
    selfTeamCode?: string;
  };
}
const FooterInfoBox = (props: props) => {
  const PopUpInfoComRef = useRef<HTMLDivElement>(null);
  const PopupComRef = useRef<HTMLDivElement>(null);
  // 活动值明细弹窗引用
  const activityValueDetailPopupRef = useRef<ActivityValueDetailPopupRef>(null);
  const [teamName, setTeamName] = useState("");
  const [pageVersionDto, setPageVersionDto] = useState<PageDataConfig | null>(
    null,
  );
  const [uid, setUid] = useState("");
  const { pageOrigin, handleShare } = useConfigPage();

  const flexCenter = { display: "flex", alignItems: "center" };
  const {
    infoObj,
    moduleJsonData,
    isPeoModel,
    onRefresh,
    activityInfo,
    teamConfigData,
  } = props;

  const activityCode = useMemo(
    //活动详情
    () => {
      const result =
        enhancedSafeChainFind(moduleJsonData)?.base("reActivity")?.val?.valCode;
      return result || moduleJsonData?.base?.[0]?.val?.valCode;
    },
    [moduleJsonData],
  );

  const shareParams = useMemo(() => {
    return {
      activityCode: activityCode || "",
      teamCode: teamConfigData?.selfTeamCode || "",
      shareType: "ranking",
    };
  }, [activityCode, teamConfigData]);

  // 创建队伍背景图
  const PopupComBacUrl = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("popSetting")
      ?.content("rankCreateTeam")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[2]?.content?.[1]?.val
    );
  }, [moduleJsonData]);

  const bgImgUrl = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("bgSetting")
      ?.content("rankListBg")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[0]?.content?.[1]?.val
    );
  }, [moduleJsonData]);

  const btnThemeColor = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("btnSetting")
      ?.content("btnThemeColor")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[4]?.val
    );
  }, [moduleJsonData]);
  const btnAssistColor = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("btnSetting")
      ?.content("btnAssistColor")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[5]?.val
    );
  }, [moduleJsonData]);

  const hdFontVal = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "activityValueName",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[3]?.val;
  }, [moduleJsonData]);

  const rankPartake = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("btnSetting")
      ?.content("rankPartake")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[0]?.val
    );
  }, [moduleJsonData]);
  const rankCreate = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("btnSetting")
      ?.content("rankCreate")?.val?.val;
    return (
      result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[0]?.val
    );
  }, [moduleJsonData]);
  const visualStyleTypeName = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "visualStyle",
    )?.val?.typeName;
    return result || moduleJsonData?.visual?.visualData?.[0]?.typeName;
  }, [moduleJsonData]);

  // 字体样式相关的useMemo
  const myRankStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("myRank")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[3]
        ?.styleData
    );
  }, [moduleJsonData]);

  const activityValueStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("activityValue")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[5]
        ?.styleData
    );
  }, [moduleJsonData]);

  const isNewBigRanking = useMemo(
    () => visualStyleTypeName == "大排行榜（新）",
    [visualStyleTypeName],
  );

  const {
    activityStatus,
    activityStatusCn,
    selfMatchFlag, //当前用户是否满足人群
    selfUserUrl,
    selfActivityValue,
    selfTeamActivityValue,
    selfActivityRank,
    selfTeamActivityRank,
    selfSignUpFlag, // 1 为报名  0 为未报名
    activityName,
    teamFlag,
    peopleMin, //是否达到队伍人数下限
    peopleMinFlag, //是否达到队伍人数下限
  } = infoObj;
  // 活动未开始
  const teamList = useMemo(() => {
    // 把我的头像换成selfUserUrl
    if (!teamConfigData?.memberList || !teamConfigData?.memberList.length)
      return [];
    let result = teamConfigData?.memberList.sort((a) => {
      if (a.memberUid === uid) {
        return -1;
      }
      return 0;
    });
    result = result?.map((item) => ({
      ...item,
      memberUrl:
        item.memberUid === uid
          ? selfUserUrl
          : "https://xps14.xiaopeng.com/6f6ca5d3a2c5deb839db293de5f8c387.png",
    }));
    // 最多展示5个，超5个取前5个+...图标
    if (result?.length && result?.length > 5) {
      result.splice(5, result.length - 5, {
        memberUrl: iconMore,
      });
    }
    return result;
  }, [teamConfigData, uid, selfUserUrl]);
  //是否达到队伍人数下限
  const isPeopleMinFlag = useMemo(() => peopleMinFlag === "1", [peopleMinFlag]);
  const isNotStarted = useMemo(() => activityStatus === "2", [activityStatus]);
  // 活动是否结束
  const isOver = useMemo(() => activityStatus === "4", [activityStatus]);
  const inActionTime = useMemo(
    () => activityStatus === "1" || activityStatus === "3",
    [activityStatus],
  );
  // 活动是否正在进行中 满足参加条件 并且报名了
  const isActive = useMemo(
    () =>
      inActionTime &&
      selfMatchFlag &&
      ((isPeoModel && selfSignUpFlag == "1") ||
        (!isPeoModel && teamFlag == "1")),
    [inActionTime, selfMatchFlag, isPeoModel, selfSignUpFlag, teamFlag],
  );
  //用户不满足参加条件
  const isNotSatisfied = useMemo(
    () => !selfMatchFlag && inActionTime,
    [selfMatchFlag, inActionTime],
  );
  const pmInfo = useMemo(
    () =>
      isPeoModel
        ? `我的排名: ${selfActivityRank}`
        : `队伍排名: ${isPeopleMinFlag ? selfTeamActivityRank : "-"}`,
    [isPeoModel, selfActivityRank, isPeopleMinFlag, selfTeamActivityRank],
  );
  // 我的排名 队伍排名 ojbect形式
  const pmInfoObj = useMemo(
    () =>
      isPeoModel
        ? {
            title: "我的排名",
            value: selfActivityRank,
          }
        : {
            title: "队伍排名",
            value: isPeopleMinFlag ? selfTeamActivityRank : "-",
          },
    [isPeoModel, selfActivityRank, isPeopleMinFlag, selfTeamActivityRank],
  );
  // 没报名 个人没报名 队伍也没报名
  const isNotSignUp = useMemo(
    () =>
      selfMatchFlag &&
      ((isPeoModel && selfSignUpFlag == "0") ||
        (!isPeoModel && teamFlag == "0")),
    [selfMatchFlag, isPeoModel, selfSignUpFlag, teamFlag],
  );
  // 报名方法
  const signUpEvent = async () => {
    try {
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      const res = await signUp({
        uid,
        activityCode,
      });
      if (res.code == 200 && res.data) {
        onRefresh(true);
        PopUpInfoComRef.current?.onOpen();
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error) {
      console.log("%c Line:102 🥔 error", "color:#7f2b82", error);
    } finally {
      Loading.hide();
    }
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: activityStatusCn || "",
      clickLocation: "立即参与",
    });
  };
  // 创建队伍
  const createTeamEvent = () => {
    setTeamName("");
    PopupComRef.current?.onOpen();
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: activityStatusCn || "",
      clickLocation: "创建队伍",
    });
  };
  const inviteMember = () => {
    const params = {
      shareUid: uid || "",
      pageCode: getParamsFromHash("pageCode") || "",
      ...shareParams,
    };
    const sharePath = removeUrlParameters(window.location.href, "", true);
    handleShare!({
      ...pageVersionDto,
      sharePageUrl: appendParamsToUrl(sharePath, params),
    });
  };
  const filterWords = new Filter();
  const filterIn = ["何小鹏", "G8", "g8"];
  const onCallback = async () => {
    try {
      const filteredText = filterWords.clean(teamName);
      let flag = false;
      filterIn.forEach((item) => {
        if (teamName.includes(item)) {
          flag = true;
        }
      });
      if (teamName != filteredText || flag) {
        Toast.show({
          content: "输入不能包含敏感内容",
        });
        return;
      }
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      //创建队伍回调
      const res = await createTeam({
        uid,
        activityCode,
        teamName,
      });
      console.log("%c Line:93 🥥 res", "color:#ea7e5c", res);
      if (res.code == 200) {
        if (res.data) {
          PopUpInfoComRef.current?.onOpen();
          onRefresh(false);
        }
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error) {
      console.log("%c Line:93 🥥 error", "color:#ea7e5c", error);
    } finally {
      Loading.hide();
    }
    trackGdp("P20217", "B002", {
      // 点击埋点
      trackName: "充电_排行榜_我的队伍_按钮点击",
      origin: getChannel(),
      activityId: activityInfo.connectedActivitiesId,
      clickLocation: "立即创建",
    });
  };

  // 查看我的队伍
  const seeMyTeam = async () => {
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: activityStatusCn || "",
      clickLocation: "我的队伍",
    });
    goToPageV2({
      hash: "/myTeam",
      params: {
        activityCode,
        hdFontVal,
        isOver,
        pageCode: activityInfo.pageCode,
        versionCode: activityInfo.versionCode,
        activityId: activityInfo.connectedActivitiesId,
        moduleId: activityInfo.moduleId,
        pageOrigin,
      },
    });
  };

  //查看明细
  const seeDetailPage = () => {
    console.log("seeDetailPage", activityValueDetailPopupRef.current);
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: visualStyleTypeName,
      status: activityStatusCn || "",
      clickLocation: "查看个人明细",
    });
    // 使用弹窗显示活动值明细
    activityValueDetailPopupRef.current?.show({
      activityCode,
      hdFontVal,
      selfActivityValue,
      isOver: activityStatus,
      pageCode: activityInfo.pageCode || "",
    });
  };

  const teamInputChange = (val: string) => {
    setTeamName(val);
  };

  useEffect(() => {
    const fetchUid = async () => {
      const uid = await getCurrentUid();
      setUid(uid);
    };
    fetchUid();
  }, []);

  useEffect(() => {
    const sessionPageVersionDto =
      JSON?.parse(
        sessionStorage?.getItem(`pageVersionDto${activityInfo.pageCode}`) ||
          localStorage?.getItem(`pageVersionDto${activityInfo.pageCode}`) ||
          "null",
      ) || {};
    console.log(
      "sessionPageVersionDto-------------------",
      sessionPageVersionDto,
    );
    if (Object.keys(sessionPageVersionDto).length != 0) {
      setPageVersionDto(sessionPageVersionDto);
    }
  }, [activityInfo.pageCode]);

  if (isNewBigRanking) {
    return (
      <div
        className={style["bgBox"]}
        style={{
          height: "auto",
        }}
      >
        <div
          className={style["Box"]}
          style={{
            height: "auto",
            backgroundImage: `url(${processOssImage(bgImgUrl)})`,
            paddingBottom: "30px",
            paddingTop: "15px",
          }}
        >
          {isNotStarted && (
            <div style={{ ...flexCenter, justifyContent: "center" }}>
              <div className={style["infoFont"]}>活动未开始</div>
            </div>
          )}
          {/* 结束并且没报名的用户才是显示活动已结束 */}
          {isOver && isNotSignUp && (
            <div style={{ ...flexCenter, justifyContent: "center" }}>
              <div className={style["infoFont"]}>活动已结束</div>
            </div>
          )}
          {isNotSatisfied && (
            <div style={flexCenter}>
              <div className={style["infoFont"]}>
                您暂不符合参与条件，请点击活动详情查看参与条件
              </div>
            </div>
          )}
          {!isOver && isNotSignUp && !isNotStarted && (
            <div className={style["bottomBox"]}>
              <div
                className={style["buttonBtn"]}
                style={{
                  backgroundColor: btnThemeColor || "#333",
                  color: btnAssistColor || "#fff",
                }}
                onClick={isPeoModel ? signUpEvent : createTeamEvent}
              >
                {`${isPeoModel ? "立即参与" : "创建队伍"}`}
              </div>
              <div className={style["infoBoxCenterMargin"]}>
                <div className={style["infoBoxNew"]}>
                  <div className={style["infoFont"]}>
                    {`暂无${isPeoModel ? "个人" : "队伍"}排名`}，点击
                    {`${isPeoModel ? "参与活动" : "创建队伍"}`}，赢得超值奖励
                  </div>
                </div>
              </div>
            </div>
          )}
          {(isActive || (isOver && !isNotSignUp)) && (
            <>
              {isPeoModel && (
                <div
                  className={style["inProgressBox"]}
                  style={{ height: "auto", justifyContent: "flex-start" }}
                >
                  <div className={style["yuanTX"]}>
                    <img src={processOssImage(selfUserUrl)} alt="找不到图片" />
                  </div>
                  <div className={style["infoBox"]}>
                    <FontSetBox content={pmInfo} styleData={myRankStyleData} />
                    <div
                      className={`${style["flexCenter"]} ${style["gayFont"]}`}
                    >
                      <FontSetBox
                        content={`${hdFontVal}: ${selfActivityValue}`}
                        styleData={activityValueStyleData}
                      />
                      <div
                        className={style["seeDetail"]}
                        onClick={seeDetailPage}
                      >
                        查看个人明细
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!isPeoModel && (
                <div
                  className={style["inProgressBox"]}
                  style={{
                    height: "auto",
                    padding: "0 94rem",
                    flexDirection: "column",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className={style["infoBoxNew"]}>
                    <div className={style["myTeamWrapper"]}>
                      <span>{`${pmInfoObj.title}: `}</span>
                      <span
                        className={style["myTeamHighLight"]}
                      >{`${pmInfoObj.value}`}</span>
                    </div>
                    <div
                      className={style["myTeamWrapper"]}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <span>{`${hdFontVal}: `}</span>
                      <span
                        className={style["myTeamHighLight"]}
                      >{`${selfTeamActivityValue}`}</span>
                    </div>
                  </div>
                  <div onClick={seeMyTeam} className={style["myTeamWrapper"]}>
                    我的队伍（<span>{teamConfigData?.peopleCount}</span>/
                    <span>{teamConfigData?.peopleMax}</span>）
                    {/* 组队模式下显示团队成员头像 */}
                    {teamList && teamList?.length > 0 ? (
                      <div
                        className={style["teamAvatarsContainer"]}
                        style={{ position: "relative", margin: "0 10px" }}
                      >
                        {teamList?.map(
                          (user: { memberUrl: string }, i: number) => (
                            <div
                              className={style["yuanTX"]}
                              key={`team-${i}`}
                              style={{
                                zIndex: -i + 9,
                                transform: `translateX(50%) translateX(${(i - Math.min(teamList?.length, 3) / 2) * 20}px)`,
                              }}
                            >
                              <img
                                src={processOssImage(user.memberUrl)}
                                alt="找不到图片"
                                className={style["teamAvatarImg"]}
                              />
                            </div>
                          ),
                        )}
                      </div>
                    ) : (
                      <div
                        className={style["yuanTX"]}
                        style={{ margin: "0 10px" }}
                      >
                        <img
                          src={processOssImage(selfUserUrl || "")}
                          alt="找不到2图片"
                        />
                      </div>
                    )}
                    <RightOutline
                      style={{
                        transform: `translateX(${(teamList?.length - 1) * 20}px)`,
                      }}
                    />
                  </div>
                  {!isOver &&
                    Number(teamConfigData?.peopleCount) <
                      Number(teamConfigData?.peopleMax) && (
                      <div
                        className={style["buttonBtn"]}
                        style={{
                          backgroundColor: btnThemeColor || "#000",
                          color: btnAssistColor || "#fff",
                        }}
                        onClick={inviteMember}
                      >
                        继续邀请
                      </div>
                    )}
                </div>
              )}
            </>
          )}
          <PopUpInfoCom
            title={isPeoModel ? "报名成功" : "创建队伍成功"}
            sureBtnStr="知道了"
            content={
              isPeoModel
                ? `您已成功参与【${activityName}】，立即行动赢取奖励吧！`
                : `你已成功创建【${teamName}】，立即行动赢取奖励吧！`
            }
            ref={PopUpInfoComRef}
            onCallback={isPeoModel ? undefined : seeMyTeam}
          />
          <PopupCom
            ref={PopupComRef}
            height={600}
            bacUrl={PopupComBacUrl}
            onCallback={onCallback}
            isNotAllowedCallBack={teamName.length == 0}
            title="创建队伍"
            btnStr="立即创建"
            children={
              <Input
                placeholder="作为队长，想一个有趣的队名吧"
                value={teamName}
                className={style["teamName"]}
                maxLength={10}
                onChange={teamInputChange}
              />
            }
          ></PopupCom>

          {/* 活动值明细弹窗组件 */}
          <ActivityValueDetailPopup
            ref={activityValueDetailPopupRef}
            moduleJsonData={moduleJsonData}
            activityInfo={activityInfo}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={style["bgBox"]}>
      <div
        style={{
          backgroundImage: `url(${processOssImage(bgImgUrl)})`,
          backgroundSize: "100%",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
        className={style["Box"]}
      >
        {isNotStarted && (
          <div style={{ ...flexCenter, justifyContent: "center" }}>
            <div className={style["infoFont"]}>活动未开始</div>
          </div>
        )}
        {/* 结束并且没报名的用户才是显示活动已结束 */}
        {isOver && isNotSignUp && (
          <div style={{ ...flexCenter, justifyContent: "center" }}>
            <div className={style["infoFont"]}>活动已结束</div>
          </div>
        )}
        {isNotSatisfied && (
          <div style={flexCenter}>
            <div className={style["infoFont"]}>
              您暂不符合参与条件，请点击活动详情查看参与条件
            </div>
          </div>
        )}
        {!isOver && isNotSignUp && !isNotStarted && (
          <div className={style["inProgressBox"]}>
            <div style={flexCenter}>
              <div className={style["infoBox"]}>
                <div
                  className={style["infoFont"]}
                >{`暂无${isPeoModel ? "个人" : "队伍"}排名`}</div>
                <div style={flexCenter} className={style["gayFont"]}>
                  <div className={style["infoFont"]}>
                    参与活动，赢得超值奖励
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundImage: `url(${processOssImage(isPeoModel ? rankPartake : rankCreate)})`,
                backgroundSize: "100%",
                backgroundPosition: "top",
                backgroundRepeat: "no-repeat",
              }}
              className={style["blackBtn"]}
              onClick={isPeoModel ? signUpEvent : createTeamEvent}
            ></div>
          </div>
        )}
        {(isActive || (isOver && !isNotSignUp)) && (
          <div className={style["inProgressBox"]}>
            <div style={flexCenter}>
              <div className={style["yuanTX"]}>
                <img src={processOssImage(selfUserUrl)} alt="找不到图片" />
              </div>
              <div className={style["infoBox"]}>
                <FontSetBox content={pmInfo} styleData={myRankStyleData} />
                <div style={flexCenter} className={style["gayFont"]}>
                  {isPeoModel && (
                    <FontSetBox
                      content={`${hdFontVal}: ${selfActivityValue}`}
                      styleData={activityValueStyleData}
                    />
                  )}
                  {!isPeoModel && isPeopleMinFlag && (
                    <FontSetBox
                      styleData={activityValueStyleData}
                      content={`${hdFontVal}: ${selfTeamActivityValue}`}
                    />
                  )}
                  {!isPeoModel && !isPeopleMinFlag && (
                    <div
                      className={style["infoFont"]}
                    >{`队伍成员未达到${peopleMin}人，暂无排名`}</div>
                  )}

                  {(isPeopleMinFlag || isPeoModel) && (
                    <div className={style["seeDetail"]} onClick={seeDetailPage}>
                      查看个人明细
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!isPeoModel && (
              <div onClick={seeMyTeam}>
                查看我的队伍
                <RightOutline />
              </div>
            )}
          </div>
        )}
        <PopUpInfoCom
          title={isPeoModel ? "报名成功" : "创建队伍成功"}
          sureBtnStr="知道了"
          content={
            isPeoModel
              ? `您已成功参与【${activityName}】，立即行动赢取奖励吧！`
              : `你已成功创建【${teamName}】，立即行动赢取奖励吧！`
          }
          ref={PopUpInfoComRef}
          onCallback={isPeoModel ? undefined : seeMyTeam}
        />
        <PopupCom
          ref={PopupComRef}
          height={600}
          bacUrl={PopupComBacUrl}
          onCallback={onCallback}
          isNotAllowedCallBack={teamName.length == 0}
          title="创建队伍"
          btnStr="立即创建"
          children={
            <Input
              placeholder="作为队长，想一个有趣的队名吧"
              value={teamName}
              className={style["teamName"]}
              maxLength={10}
              onChange={teamInputChange}
            />
          }
        ></PopupCom>

        {/* 活动值明细弹窗组件 */}
        <ActivityValueDetailPopup
          ref={activityValueDetailPopupRef}
          moduleJsonData={moduleJsonData}
          activityInfo={activityInfo}
        />
      </div>
    </div>
  );
};

export default FooterInfoBox;
